import React from 'react';
import Landing from './Components/Pages/Landing/LandingPage';

export default function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}